import React from 'react';
import classNames from 'classnames';
import Immutable from 'immutable';

import { Paragraph } from '@uncinc/react-drupal-core';
import {
  Image,
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';
import { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { NodeProject } from '../../../../types/uncinc_profile/nodes';

import './style.scss';

interface NodeProjectPageProps extends React.ComponentPropsWithoutRef<'div'> {
  entity: ImmutableEntity<NodeProject>;
}

const NodeProjectPage: React.FC<NodeProjectPageProps> = ({ entity }) => {
  const classes = classNames('NodeProjectPage');
  const project = entity.toJS();
  const title = project.title[0].value;
  const image = project.field_media_item[0]?.entity.field_media_image[0]?.source;
  const paragraphs = project.field_paragraphs;
  const body = project.body[0]?.processed;

  return (
    <article itemType="http://schema.org/WebPage" className={classes}>
      <div className="NodeProjectPage__hero">
        {image && (
          <div className="NodeProjectPage__hero__image">
            <Image
              src={image}
              alt={title}
              lazyload={false}
            />
          </div>
        )}
        <div className="NodeProjectPage__hero__text">
          <h1 itemProp="name">{title}</h1>
          {body ? (
            <WysiwygField
              property="schema:text"
              html={body}
            />
          ) : null}
        </div>
      </div>

      {paragraphs.length !== 0 ? (
        <div className="NodeProjectPage__paragraphs">
          {paragraphs.map((paragraph) => {
            const id = paragraph.target_id;
            const language = paragraph.entity.langcode[0].value;
            return (
              <Paragraph
                key={`paragraph:${id}:${language}`}
                entity={Immutable.fromJS(paragraph.entity)}
              />
            );
          })}
        </div>
      ) : null}
    </article>
  );
};

export default NodeProjectPage;
